import { GameLayer } from "../GameLayer";
import * as leaflet from "leaflet";
import { Vector2 } from "../../math";
import { GameMap } from "../GameMap";
import { LeafletPolygonConstructors } from "../LeafletPolygonConstructors";
var tilePolygon = LeafletPolygonConstructors.tilePolygon;
export class TileHighlight extends leaflet.FeatureGroup {
    constructor(position = { x: 0, y: 0 }, color = "#F0780C") {
        super();
        this.position = position;
        this.color = color;
        this._polygon = null;
        this.update();
    }
    setPosition(position) {
        if (Vector2.eq(position, this.position))
            return;
        this.position = position;
        this.update();
    }
    update() {
        if (this._polygon) {
            this._polygon.remove();
            this._polygon = null;
        }
        this._polygon = tilePolygon(this.position).setStyle({
            fillOpacity: 0.2,
            opacity: 0.8,
            color: this.color,
            fillColor: this.color,
            interactive: false,
            pane: GameMap.objectPane
        }).addTo(this);
    }
}
export default class TileHighlightLayer extends GameLayer {
    constructor() {
        super(...arguments);
        this.tile_highlight = new TileHighlight({ x: 0, y: 0 }).addTo(this);
    }
    eventHover(event) {
        event.onPre(() => {
            this.tile_highlight.setPosition(event.tile());
        });
    }
}
